import React from "react";
import { useForgetPasswordVM } from "./ForgetPasswordViewModel";
import ForgetPasswordView from "./ForgetPasswordView";

const ForgetPasswordPage: React.FC = () => {
  const vm = useForgetPasswordVM();

  return <ForgetPasswordView state={vm.state} actions={vm.actions} />;
};

export default ForgetPasswordPage;